module.exports = __webpack_public_path__ + "static/img/share.9813b8b9.svg";